"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.specialCoverageMap = exports.LUXURY_TRANSPORTATION_SERVICE = exports.ASSAMOVIL_BASIC = exports.ASSAMOVIL_PLUS = exports.ASSAMOVIL_PREMIUM = void 0;
/**
 * Since the assamovil coverage is treated as a regular coverage by the backend, but
 * has a different type of coverage by the business, a special case needs to be applied
 * for it via the code. NOTE that if for some reason this code changes in the backend,
 * this constant must be updated.
 */
exports.ASSAMOVIL_PREMIUM = '0230';
exports.ASSAMOVIL_PLUS = '0229';
exports.ASSAMOVIL_BASIC = '0228';
exports.LUXURY_TRANSPORTATION_SERVICE = '0104';
var ASSAMOVIL_LABEL_TITLE = 'Asistencia vial exclusiva';
var LUXURY_TRANSPORTATION_LABEL = 'USO DEL AUTO PARA SERVICIO DE TRANSPORTE DE LUJO';
/**
 * These are the actual values displayed for the "special" coverages.
 * This is basically what tue ui must "map" to display the correct values
 */
exports.specialCoverageMap = (_a = {},
    _a[exports.ASSAMOVIL_PREMIUM] = {
        code: exports.ASSAMOVIL_PREMIUM,
        label: ASSAMOVIL_LABEL_TITLE,
        content: 'ASSAMóvil Premium',
    },
    _a[exports.ASSAMOVIL_PLUS] = {
        code: exports.ASSAMOVIL_PLUS,
        label: ASSAMOVIL_LABEL_TITLE,
        content: 'ASSAMóvil Plus',
    },
    _a[exports.ASSAMOVIL_BASIC] = {
        code: exports.ASSAMOVIL_BASIC,
        label: ASSAMOVIL_LABEL_TITLE,
        content: 'ASSAMóvil Básico',
    },
    _a[exports.LUXURY_TRANSPORTATION_SERVICE] = {
        code: exports.LUXURY_TRANSPORTATION_SERVICE,
        label: LUXURY_TRANSPORTATION_LABEL,
        content: '',
    },
    _a);
//# sourceMappingURL=specialCoverages.js.map